export default __webpack_public_path__ + "static/media/tutorial6-1.0ca1bd6e.png";